import { getAssetPath } from "./assetPath";
let CACHED_MAP;
export const addIcons = (icons) => {
    const map = getIconMap();
    Object.keys(icons).forEach(name => map.set(name, icons[name]));
};
export const getIconMap = () => {
    if (typeof window === 'undefined') {
        return new Map();
    }
    else {
        if (!CACHED_MAP) {
            const win = window; // eslint-disable-line @typescript-eslint/no-explicit-any
            win.PdsIcons = win.PdsIcons || {};
            CACHED_MAP = win.PdsIcons.map = win.PdsIcons.map || new Map();
        }
        return CACHED_MAP;
    }
};
export const getName = (iconName, icon) => {
    if (!iconName && icon && !isSrc(icon)) {
        iconName = icon;
    }
    if (isStr(iconName)) {
        iconName = toLower(iconName);
    }
    if (!isStr(iconName) || iconName.trim() === '') {
        return null;
    }
    const invalidChars = iconName.replace(/[a-z]|-|\d/gi, '');
    if (invalidChars != '') {
        return null;
    }
    return iconName;
};
const getNamedUrl = (iconName) => {
    const url = getIconMap().get(iconName);
    if (url) {
        return url;
    }
    return getAssetPath(`svg/${iconName}.svg`);
};
export const getSrc = (src) => {
    if (isStr(src)) {
        src = src.trim();
        if (isSrc(src)) {
            return src;
        }
    }
    return null;
};
export const getUrl = (pdsIcon) => {
    let url = getSrc(pdsIcon.src);
    if (url) {
        return url;
    }
    url = getName(pdsIcon.name, pdsIcon.icon);
    if (url) {
        return getNamedUrl(url);
    }
    if (pdsIcon.icon) {
        url = getSrc(pdsIcon.icon);
        if (url) {
            return url;
        }
    }
    return null;
};
export const isSrc = (str) => str.length > 0 && /(\/|\.)/.test(str);
export const isStr = (val) => typeof val === 'string'; // eslint-disable-line @typescript-eslint/no-explicit-any
export const toLower = (val) => val.toLowerCase();
/**
 * Elements inside of web components sometimes need to inherit global attributes
 * set on the host. For example, the inner input in `ion-input` should inherit
 * the `title` attribute that developers set directly on `ion-input`. This
 * helper function should be called in componentWillLoad and assigned to a variable
 * that is later used in the render function.
 *
 * This does not need to be reactive as changing attributes on the host element
 * does not trigger a re-render.
 */
export const inheritAttributes = (el, attributes = []) => {
    const attributeObject = {}; // eslint-disable-line @typescript-eslint/no-explicit-any
    attributes.forEach(attr => {
        if (el.hasAttribute(attr)) {
            const value = el.getAttribute(attr);
            if (value !== null) {
                attributeObject[attr] = el.getAttribute(attr);
            }
            el.removeAttribute(attr);
        }
    });
    return attributeObject;
};
//# sourceMappingURL=utils.js.map
